import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisplayCurrencyComponent } from './display-currency.component';



@NgModule({
  declarations: [
    DisplayCurrencyComponent
  ],
  imports: [
    CommonModule
  ], exports: [DisplayCurrencyComponent]
})
export class DisplayCurrencyModule { }
